module.exports = __webpack_public_path__ + "img/asus-ux481-duo.c91bc86f.jpg";